/**
 * Button List Mixin
 * @desc Handles logic for button lists in the application
 */
import scroll from '@/mixins/scroll'

export default {
  // Mixins
  mixins: [scroll],

  // Mounted
  mounted () {
    if (!this[this.buttonListFieldName]) {
      this.$_buttonList_setDefaultValue()
    } else {
      this.buttonListDefaultSelected = false
    }
  },
  // Data
  data () {
    return {
      buttonListDefaultSelected: true
    }
  },

  // Computed
  computed: {
    $_buttonList_activeButton () {
      if (!this.buttons) return
      return this.buttons.filter(button => button.value === this[this.buttonListFieldName])[0]
    },

    $_buttonList_activeDataLayer () {
      if (!this.$_buttonList_activeButton) return
      return this.$_buttonList_activeButton.dataLayer
    },

    $_buttonList_dataLayerObject () {
      if (!this.$_buttonList_activeDataLayer) return
      if (!this.buttonListDataLayerStepName) return

      return {
        ...this.dataLayerObject,
        [this.buttonListDataLayerStepName]: `${this.buttonListDataLayerStepName}_${this.$_buttonList_activeDataLayer}${this.buttonListDefaultSelected ? '_default' : ''}`,
        event: `${this.buttonListDataLayerStepName}_continue`
      }
    }
  },

  // Methods
  methods: {
    /**
     * Set Default Value
     */
    $_buttonList_setDefaultValue (actionName = this.buttonListActionName, buttons = this.buttons, valueKey = 'value') {
      if (!actionName) return
      if (!buttons) return console.warn('\'buttons\' not set.')
      this.$store.dispatch(actionName, buttons[0][valueKey])
    },

    /**
     * Handle Input / Click
     */
    $_buttonList_handleInput (actionName, value) {
      if (!actionName) return console.warn('\'actionName\' not set.')
      const button = document.querySelector('.app-button')
      const windowBottom = window.scrollY + window.innerHeight
      const buttonBottomPos = button.getBoundingClientRect().bottom + window.scrollY

      if (buttonBottomPos > windowBottom) this.$_scroll_elementIntoView('.step-footer')

      this.buttonListDefaultSelected = false
      this.$store.dispatch(actionName, value)
    }
  }
}
